export default {
    token: (state) => state.permission.userInfo ? state.permission.userInfo.token : null,
    uid: (state) => state.permission.userInfo ? state.permission.userInfo.id : null,
    pms: state => state.data.permissionData,
    userInfo: (state) => state.permission.userInfo ? state.permission.userInfo : null,
    showAside: state => state.tool.isShow, //判断侧边栏
    asideData: state => state.data.asideData || [], //侧边栏数据
    navIndex: state => state.data.navIndex, //当前头部导航的下标
    headImg: (state) => state.permission.userInfo ? state.permission.userInfo.headImg : '', //登录用户的头像
    nickname: (state) => state.permission.userInfo ? state.permission.userInfo.nickName : '',
    permission: state => state.permission.permission, //权限
    pushId: (state) => state.permission.pushId ? state.permission.pushId : null, //用于连接leanCloud
    signalData: (state) => state.realData.signalData ? state.realData.signalData : {},
    realData: (state) => state.realData.realData ? state.realData.realData : null, //实时数据
    //实时数据指令部分
    commandResult: (state) => state.realData.commandResult ? state.realData.commandResult : null, //实时数据--指令
    //固件升级部分
    firmwareHistoryDetail: (state) => state.realData.firmwareHistoryDetail ? state.realData.firmwareHistoryDetail : null,
    firmwareHistoryList: (state) => state.realData.firmwareHistoryList ? state.realData.firmwareHistoryList : null,
};


// WEBPACK FOOTER //
// ./src/store/getters.js